import * as React from 'react';
import { Element, scroller } from 'react-scroll';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from '../../node_modules/redux';
import { withRouter } from 'react-router';

import userActions from '../user/userActions';
import authActions from '../auth/authActions';

import HomePageAssessment from './HomePageAssessment';
import HomePageAssessmentBottom from './HomePageAssessmentBottom';
import { Page } from '../components/common';
import { SectionLeft, SectionMain, SectionRight } from '../components/sections';
import Button from '../components/buttons/Button';
import { IconArrowDown, LogoFirstCanadian, IconRunningShoes } from '../components/icons';

import logoMosaicLifeInverseNoTmSrc from '../assets/images/logo-mosaic-life-inverse-no-tm.svg';
import logoRunningRoomInverseSrc from '../assets/images/logo-running-room-inverse.svg';
const scorLogoSrc = require('../assets/images/logo-scor.png');

interface Props {
	actions: any;
	history: any;
	currentUser: UserDetails;
	referrerName: string;
	match: any;
}
class RunningHomePage extends React.Component<Props, any> {
	constructor(props: Props) {
		super(props);
	}

	componentWillMount() {
		document.body.classList.add('page-running-room');
	}

	componentDidMount() {
		if (this.props.currentUser.isAuthenticated) {
			if ( this.props.currentUser.role !== undefined) {
				if ( this.props.currentUser.role[0] !== 'Customer' ) {
					if (this.props.currentUser.role.some(r => r === 'Adjudicator')) {
						return this.props.history.push('/admin/adjudication');
					} else {
						return this.props.history.push('/admin');
					}
				} 
				else if (!this.props.currentUser.hasBeenDirected) {
					this.props.actions.doneDirect(this.props.currentUser);
					return this.props.history.push('/user');			
				} 
			} 
		}
		const referralCode = 'RunningRoom';
		this.props.actions.setReferralCode(referralCode);
	}

	componentWillUnmount() {
		document.body.classList.remove('page-running-room');
	}

	onAltCtaClick = () => {
		let topOffset = 15;
		const navbar = document.querySelector('.navbar-wrapper.fixed-top');

		if (navbar) {
			topOffset += navbar.clientHeight;
		}

		scroller.scrollTo('homePageAssessment', {
			duration: 300,
			smooth: true,
			offset: -topOffset
		});
	}

	render() {
		return (
			<Page>
				<Helmet>
					<meta charSet="utf-8"/>
					<meta
						name="description"
						content={`Simple. Direct. Affordable. Discover your life insurance options in just 10 minutes` +
						`and receive a free pair of running shoes from the Running Room when you apply.`}
					/>
					<title>Mosaic Life - Simple & Afforadable Life Insurance | Runners</title>
				</Helmet>
				<header className="page-hero page-hero-running page-hero-lg">
					<div className="page-hero-content">
						<div className="container">
							<div className="row">
								<div className="col-md-5 text-light d-flex flex-column">
									<div>
										<SectionLeft columns={12} wrapperClassName="page-hero-partners" sectionClassName="pt-3 pr-3 pb-3 pl-0">
											<div className="d-flex align-items-center">
												<img src={logoRunningRoomInverseSrc} className="page-hero-partner-logo" alt="Running Room Logo" />
												<span className="mx-3">+</span>
												<img src={logoMosaicLifeInverseNoTmSrc} className="page-hero-partner-logo" title="Mosaic Life Logo" />
											</div>
										</SectionLeft>
										<h1 className="page-hero-title page-title-display mb-0 mb-md-2">
											Life insurance for runners
										</h1>
										<p className="mb-0 page-hero-lead-lg max-read-width mt-1 mb-3 strong">
											Sign up and get a free pair of <span className="d-inline-block">running shoes! *</span>
										</p>
										<Button
											className="btn-primary btn-primary-inverse my-3 page-hero-cta-alt"
											onClick={this.onAltCtaClick}
										>
											Get started
											<IconArrowDown className="ml-2" />
										</Button>
									</div>
								</div>
								<div className="col-md-6 offset-md-1 mt-3 mt-md-0 px-0 d-flex flex-column justify-content-center">
									<Element name="homePageAssessment" />
									<SectionRight columns={12} sectionClassName="pr-0">
										<HomePageAssessment />
									</SectionRight>
								</div>
							</div>
						</div>
					</div>
				</header>
				<div className="container my-4 my-md-6">
					<section className="card-deck">					
						<div className="card">
							<div className="card-body section section-lg">
								<h2 className="mb-3 text-primary">*Get a free pair of shoes!</h2>
								<p className="mb-0 mb-md-4 mb-lg-3">
									How it works: Sign up for a policy with a minimum premium of $25/month and we’ll send you a $150 
									Running Room gift card. Gift card will be sent by email 31 days after you enroll.
								</p>
								<IconRunningShoes className="icon-running-shoes text-primary" />
							</div>
						</div>
						<div className="card">
							<div className="card-body section section-lg">
								<h2 className="mb-3">Coverage for an active lifestyle</h2>
								<p>
									You take care of yourself and should be rewarded for it. Mosaic Life offers great rates for active people.
								</p>
							</div>
						</div>
						<div className="card">
							<div className="card-body section section-lg">
								<h2 className="mb-3">It’s easy</h2>
								<p>
									Unlike other insurers, Mosaic Life doesn’t require medical exams or urine samples.
									You can get coverage in 10 minutes, all online.
								</p>
							</div>
						</div>
					</section>
				</div>
				<section className="mt-4 mt-md-6 container d-none d-lg-block">
					<h2 className="mb-3">Why Choose Mosaic Life</h2>
					<div className="row row-x-1">
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container" onTouchStart={(e) => e}>
								<div className="flipper">
									<h3 className="front">Convenient and easy</h3>
									<div className="back">
										Most insurers require you to provide blood and urine samples and can take weeks to issue a policy.
										With Mosaic Life, you can get coverage in 10 minutes just by answering some lifestyle and health
										questions online.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Direct</h3>
									<div className="back">
										We’ve cut out the middlemen to give you an experience that’s free of hefty fees, commissions, and complexity.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-lg-3 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Team Canada</h3>
									<div className="back">Mosaic Life is proudly for Canadians, by Canadians.</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Affordable</h3>
									<div className="back">
										By skipping pricey broker commissions and taking insurance online, we’re able to offer $1 million of coverage for as little as $1/day.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-lg-3 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Guaranteed rates</h3>
									<div className="back">
										Your premiums are set for the term of your policy. Even if you get sick during your policy term,
										your premiums will not change.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Relevant</h3>
									<div className="back">
										We launched Mosaic Life out of our own need for protection. We've reimagined how life insurance
										should work&mdash;100% online, totally flexible, no brokers, simple.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Cancel anytime (with money-back guarantee)</h3>
									<div className="back">
										You can cancel your policy at any time and for any reason. If you cancel in the first 30 days, we
										will give you a full refund of your premium.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-lg-3 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">No fees</h3>
									<div className="back">
										Besides your monthly premium, there are no additional fees to obtain coverage.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Flexible</h3>
									<div className="back">
										We offer a range of terms and coverage amounts to meet your specific needs. You can have up to $1
										million in total coverage across as many policies as you would like.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-lg-3 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Insurance you can trust</h3>
									<div className="back">
										We try to be honest, transparent, and helpful. Your privacy is important to us.
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<SectionMain sectionClassName="mt-4 mt-md-6 section-lg">
					<div className="row align-items-center">
						<div className="col-md-5 col-lg-4 text-center">
							<LogoFirstCanadian className="landing-section-logo landing-section-logo-fc" />
						</div>
						<div className="col-md-7 col-lg-8 mt-4 mt-md-0">
							<p>
								Mosaic Life policies are underwritten by First Canadian Insurance Corporation, a life insurer based in Edmonton that has
								provided protection to over 1 million Canadian families.  First Canadian has been around for over 30 years and is rated
								A (with stable outlook) by A.M. Best, the leading ratings agency for insurance companies.
							</p>
						</div>
					</div>
					<div className="row align-items-center mt-4 mt-md-5">
						<div className="col-md-5 col-lg-4 text-center">
							<img src={scorLogoSrc} alt="The logo of SCOR (The Art & Science of Risk)" className="landing-section-logo landing-section-logo-scor" />
						</div>
						<div className="col-md-7 col-lg-8 mt-4 mt-md-0 order-md-first">
							<p>
								Mosaic Life is also backed by SCOR, one of the world’s largest reinsurers and a leader in the creation
								of innovative risk management solutions for insurance companies. SCOR has been around for almost 50
								years and is rated A+ (with stable outlook) by A.M. Best.
							</p>
						</div>
					</div>
				</SectionMain>
				<section className="mt-4 mt-md-6 section section-lg bg-secondary text-light">
					<div className="container">
						<HomePageAssessmentBottom />
					</div>
				</section>
			</Page>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		currentUser: state.auth.currentUser,
		referrerName: state.user.referrerName
	};
}

function mapDispatchToProps(dispatch: any) {
	const actions = {...authActions, ...userActions};
	return {
		actions: bindActionCreators(actions, dispatch),
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RunningHomePage));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/landing/RunningHomePage.tsx